export interface IEventData {
    action: string;
    payload?: any;
}

export function dispatchCustomEvent(eventName: string, data: IEventData) {
    document.dispatchEvent(
        new CustomEvent(eventName, {
            bubbles: false,
            detail: data,
        }),
    );
}
